import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/ucenter/settings.vue'
wx.createPage(MiniProgramPage)